// Reveal whole weeks so each visible matchup always has its reciprocal entry.
export function createSchedulePreview(grid, completedWeeks) {
  return grid.map(row => ({
    ...row,
    games: row.games.map((game, index) => ({
      ...game,
      opp: index < completedWeeks ? game.opp : null,
    })),
    numGames: row.games.slice(0, completedWeeks).filter(game => !!game.opp).length,
  }))
}
